import SalesMangement from './SalesMangement';

export default SalesMangement;
